module.exports = __webpack_public_path__ + "static/media/Logos_NB_grau.ae38010d.jpg";